import React, { Component, Fragment } from 'react';
import { Row, Col } from 'reactstrap';
import "moment/locale/es";
import moment from 'moment';

class FragmentsQuerysAndProcedures extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        
    }

    componentDidUpdate() {
        
        console.log("propsAudiometria",this.props.audiometria);
    }

    render() {


        const RenderMioescanography = () => {
            try {
                return (<>

                    <Row>
                        <Col md={3}>
                            <div>
                                <b>Labios</b>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Normal</th>
                                            <th scope="col">Paciente</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>0.5</td>
                                            <td>{this.props.data.mioescanografia.mioescanografia.labios}</td>

                                        </tr>
                                        <tr>
                                            <td>0.8</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div>
                                <b>Lengua</b>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Normal</th>
                                            <th scope="col">Paciente</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>0.8</td>
                                            <td>{this.props.data.mioescanografia.mioescanografia.lengua}</td>
                                        </tr>
                                        <tr>
                                            <td>1.2</td>
                                            <td></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div>
                                <b>Meseteros</b>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Normal</th>
                                            <th scope="col">Paciente</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>0.4</td>
                                            <td>{this.props.data.mioescanografia.mioescanografia.maseteros_der}</td>
                                        </tr>
                                        <tr>
                                            <td>0.7</td>
                                            <td>{this.props.data.mioescanografia.mioescanografia.maseteros_izq}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div>
                                <b>Dinamometria</b>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Normal</th>
                                            <th scope="col">Paciente</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>5 - 6 lbs</td>
                                            <td>{this.props.data.mioescanografia.mioescanografia.dinamometria}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                    </Row>
                </>);
            }
            catch (err) {
                console.log(err);
                return null;
            }
        }

        return (
            <>
                <hr />

                {this.props.data.motivo_consulta !== "" && this.props.data.motivo_consulta !== null ?
                    <Fragment  >
                        <h4 style={{ marginTop: 20 }} >Motivo Consulta</h4>
                        <p> {this.props.data.motivo_consulta}</p>
                    </Fragment>
                    : null}
                {this.props.data.procedimiento !== "" && this.props.data.procedimiento !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Procedimientos</h4>
                        <p> {this.props.data.procedimiento}</p>
                    </Fragment>
                    : null}

                {this.props.data.antecedentes_paciente !== "" && this.props.data.antecedentes_paciente !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Antecedentes del Paciente</h4>
                        <p> {this.props.data.antecedentes_paciente}</p>
                    </Fragment>
                    : null}



                {this.props.data.resultados !== "" && this.props.data.resultados !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Resultados</h4>
                        <div dangerouslySetInnerHTML={{ __html: this.props.data.resultados }} />
                    </Fragment>
                    : null}
                {this.props.data.interpretacion !== "" && this.props.data.interpretacion !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Interpretación</h4>
                        <p> {this.props.data.interpretacion}</p>
                    </Fragment>
                    : null}
                {this.props.data.observacion !== "" && this.props.data.observacion !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Observacion</h4>
                        <p> {this.props.data.observacion}</p>
                    </Fragment>
                    : null}
                {this.props.data.lengua_payne !== "" && this.props.data.lengua_payne !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Lengua en Reposo</h4>
                        <p> {this.props.data.lengua_payne}</p>
                    </Fragment>
                    : null}
                {this.props.data.observacion2 !== "" && this.props.data.observacion2 !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Observaciones (Alimentacion)</h4>
                        <p> {this.props.data.observacion2}</p>
                    </Fragment>
                    : null}
                {this.props.data.mioescanografia !== "" && this.props.data.mioescanografia !== null && this.props.data.mioescanografia != undefined ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Mio Escanografia</h4>
                        <RenderMioescanography />
                    </Fragment>
                    : null}
                {this.props.data.encuesta_inventario !== "" && this.props.data.encuesta_inventario !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Encuesta Inventario de Discapacidad por Vértigo (DHI)</h4>
                        <p> {this.props.data.encuesta_inventario}</p>
                    </Fragment>
                    : null}
                {this.props.data.pruebas_equilibrio !== "" && this.props.data.pruebas_equilibrio !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Pruebas de Equilibrio Estático y Dinámico</h4>
                        <p> {this.props.data.pruebas_equilibrio}</p>
                    </Fragment>
                    : null}
                {this.props.data.nistagmo_espontanoeo !== "" && this.props.data.nistagmo_espontanoeo !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Nistagmo Espóntaneo</h4>
                        <p> {this.props.data.nistagmo_espontanoeo}</p>
                    </Fragment>
                    : null}
                {this.props.data.maniobra_hallpike !== "" && this.props.data.maniobra_hallpike !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Maniobra de Dix Hallpike</h4>
                        <p> {this.props.data.maniobra_hallpike}</p>
                    </Fragment>
                    : null}
                {this.props.data.test_agudeza !== "" && this.props.data.test_agudeza !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Test de Agudeza Visual</h4>
                        <p> {this.props.data.test_agudeza}</p>
                    </Fragment>
                    : null}


                {this.props.data.recomendaciones !== "" && this.props.data.recomendaciones !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Recomendaciones</h4>
                        <p> {this.props.data.recomendaciones}</p>
                    </Fragment>
                    : null}
                {this.props.data.parametro_estimulacion !== "" && this.props.data.parametro_estimulacion !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Parametro Estimulacion</h4>
                        <div dangerouslySetInnerHTML={{ __html: this.props.data.parametro_estimulacion }} />
                    </Fragment>
                    : null}
                {this.props.data.conclusion !== "" && this.props.data.conclusion !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Conclusion</h4>
                        <p> {this.props.data.conclusion}</p>
                    </Fragment>
                    : null}
                {this.props.data.audiometria !== "" && this.props.data.audiometria !== null ?
                    <Fragment>
                        <p> {this.props.data.audiometria}</p>
                    </Fragment>
                    : null}
                {this.props.data.nota !== "" && this.props.data.nota !== null ?
                    <Fragment>
                        <h4 style={{ marginTop: 20 }} >Nota</h4>
                        <p> {this.props.data.nota}</p>
                    </Fragment>
                    : null}
                {this.props.data.completo !== "" && this.props.data.completo !== null ?
                    <Fragment>
                        <p> {this.props.data.completo}</p>
                    </Fragment>
                    : null}

            </>
        );
    }
}

export default FragmentsQuerysAndProcedures;
